import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { moduleActions } from '../../../redux/modules';
import { analyticsDataLayer } from '../../../redux/utils/analytics-helper';
import { getQCDSubmittedToday } from '../../../redux/modules/qcd/qcd.selectors';

import number_1 from 'src/assets/images/number_1.png';
import number_2 from 'src/assets/images/number_2.png';
import number_3 from 'src/assets/images/number_3.png';

import Button from '../../Shared/Button/Button';

import './QCDEntry.scss';
import FAQ from '../FAQ/FAQ.js';
import { appendBasePath } from '../../../utils/nav.utils';
import {
  APP_FAILURE,
  DOB_FAILURE,
  FOREIGN_ADDRESS,
  loadingExchangeAppMessages,
  NOT_RETAIL_CLIENT,
} from '../../../settings/settings';
import {
  getDateOfBirth,
  getIsNotForeignAddress,
  getPersonalInformationData,
} from '../../../redux/modules/user/PersonalInformation/personalInformation.selectors';
import { getIsCorporateAccountType } from '../../../redux/modules/shoppingCart/shoppingCart.selectors';
import {
  isCustomerWebViewEnabled,
  isSalesforceRep,
} from '../../../redux/modules/authentication/authentication.module.selectors';
import { FullPageLoader } from '../../Shared/FullPageLoader/FullPageLoader';
import { getApplicationStatus } from '../../../redux/modules/applicationData/applicationData.selectors';

export const QCDEntry = () => {
  const dispatch = useDispatch();
  const qcdSubmittedToday = useSelector(getQCDSubmittedToday);
  useEffect(() => {
    const { loadApplication, setAppLoading } = moduleActions;
    dispatch(setAppLoading());
    analyticsDataLayer();
    dispatch(loadApplication(moduleActions));
  }, [dispatch]);
  const isNotForeignAddress = useSelector(getIsNotForeignAddress);
  const dateOfBirth = useSelector(getDateOfBirth);
  const isCorporateAccountType = useSelector(getIsCorporateAccountType);
  const isSalesforceRepRoth = useSelector(isSalesforceRep);
  const { retailEnabled } = useSelector(getPersonalInformationData);
  const applicationData = useSelector(getApplicationStatus);
  const customerWebViewEnabled = useSelector(isCustomerWebViewEnabled);

  const message = loadingExchangeAppMessages;
  const isLoaderVisible = applicationData.isLoading;

  const getError = () => {
    if (applicationData.hasFailed) {
      return {
        type: APP_FAILURE,
        hasError: true,
      };
    }
    if (!dateOfBirth && !isCorporateAccountType) {
      return {
        type: DOB_FAILURE,
        hasError: true,
      };
    }
    if (!isNotForeignAddress) {
      return {
        type: FOREIGN_ADDRESS,
        hasError: true,
      };
    }
    if (!retailEnabled && !isSalesforceRepRoth) {
      return {
        type: NOT_RETAIL_CLIENT,
        hasError: true,
      };
    }
    return {
      type: '',
      hasError: false,
    };
  };

  return (
    <div id="page-container" className="container">
      <FullPageLoader
        isVisible={isLoaderVisible}
        hasError={getError().hasError}
        errorType={getError().type}
        messages={message}
      />
      <span className="qcd-header">
        <h1 className="header-title">
          Make a Qualified Charitable Distribution (QCD)
        </h1>
        <h3 className="header-substitle">
          Use your IRA to make a nontaxable donation to an eligible charity.
        </h3>
      </span>
      <span className="content">
        <span className="qcd-block">
          <p className="qcd-block-subtitle">
            A qualified charitable distribution (QCD) lets you support a cause
            important to you. If you are at least 70 1/2, you can
            <b className="qcd-block-bold">
              {' '}
              make a nontaxable QCD from your IRA.
            </b>{' '}
            A QCD may help fulfill your required minimum distribution.
          </p>
          <p className="qcd-block-subtitle qcd-block-subtitle-disclaimer">
            You may only submit one QCD online per trade date.
          </p>
          <Button
            className="btn-trp-qcd"
            disabled={qcdSubmittedToday}
            onClick={() =>
              (window.location.href = appendBasePath(
                isSalesforceRepRoth ? '/salesforce/qcd' : '/qcd'
              ))
            }
          >
            Make a QCD
          </Button>
        </span>
        <span className="next-steps">
          <h4 className="next-steps-title">Here's what's next:</h4>
          <ul className="next-steps-list">
            <li className="next-steps-list-item">
              <img src={number_1} alt="number 1 icon" className="img-num" />
              <p className="next-steps-text">
                Choose your delivery method and charity.
              </p>
            </li>
            <li className="next-steps-list-item">
              <img src={number_2} alt="number 2 icon" className="img-num" />
              <p className="next-steps-text">
                Select your funds and distribution amounts.
              </p>
            </li>
            <li className="next-steps-list-item">
              <img src={number_3} alt="number 3 icon" className="img-num" />
              <p className="next-steps-text">Review and submit your QCD.</p>
            </li>
          </ul>
        </span>
        <span className="faq-section">
          <FAQ
            isSalesforceRepRoth={isSalesforceRepRoth}
            customerWebViewEnabled={customerWebViewEnabled}
          />
          <span style={{ color: '#000', fontSize: '16px' }}>2847130</span>
        </span>
      </span>
    </div>
  );
};

export default QCDEntry;
